var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconinfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16V16ZM9.43 6.588L8.43 11.293C8.36 11.633 8.459 11.826 8.734 11.826C8.928 11.826 9.221 11.756 9.42 11.58L9.332 11.996C9.045 12.342 8.412 12.594 7.867 12.594C7.164 12.594 6.865 12.172 7.059 11.275L7.797 7.807C7.861 7.514 7.803 7.408 7.51 7.337L7.059 7.256L7.141 6.875L9.431 6.588H9.43ZM8.5 5.5C8.23478 5.5 7.98043 5.39464 7.79289 5.20711C7.60536 5.01957 7.5 4.76522 7.5 4.5C7.5 4.23478 7.60536 3.98043 7.79289 3.79289C7.98043 3.60536 8.23478 3.5 8.5 3.5C8.76522 3.5 9.01957 3.60536 9.20711 3.79289C9.39464 3.98043 9.5 4.23478 9.5 4.5C9.5 4.76522 9.39464 5.01957 9.20711 5.20711C9.01957 5.39464 8.76522 5.5 8.5 5.5V5.5Z",
    fill: "#94999E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinfo);
export default __webpack_public_path__ + "static/media/iconinfo.12c7173ecd74cc871dd5e62b6b253f39.svg";
export { ForwardRef as ReactComponent };